export const SEVERITY_LEVEL = {
  CRITICAL: 4,
  ERROR: 3,
  INFORMATION: 1,
  VERBOSE: 0,
  WARNING: 2,
};
